import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "circle-progress-ring",
  viewBox: "0 0 120 120"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  class: "circle-progress-ring__bg",
  "stroke-width": "8",
  fill: "transparent",
  r: "54",
  cx: "60",
  cy: "60"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("circle", {
      class: "circle-progress-ring__progress",
      "stroke-width": "8",
      fill: "transparent",
      r: "54",
      cx: "60",
      cy: "60",
      transform: "rotate(-90, 60, 60)",
      ref: "progress",
      style: _normalizeStyle(_ctx.progressStyle)
    }, null, 4)
  ]))
}